import moment from "moment"
import MasterComponent from "../../../../../components/Forms"
import { MasterConfigs } from "../../../../../interfaces/entity"
import { Button, Drawer, Tag, Space, notification } from "antd"
import Report from "./Report/Report"
import React, { act, useEffect, useState } from "react"
import NextRoundModal from "../Screening/modal"
import { constants } from "../../../../../constants/common"
import { allLevels } from "./AllTest"
import { useDispatch } from "react-redux"

const QualifiedCandidates = () => {
    const [isOpen, setIsOpen] = React.useState(false)
    const [selectedId, setSelectedId] = React.useState(null)
    const [selected, setSelectedRow] = useState([])
    const [nextRound, setNextRound] = useState(false)
    const level = constants.PROFILE_STATUS.TEST;
    const dispatch = useDispatch()

    const onMoveToNext = () => {
        setNextRound(true)
    }


    const config: MasterConfigs = {
        api: () => '/test-details?testResult=Shortlisted',
        modalTitle: () => 'Test Details',
        tableProps: {
            rowSelection: {
                type: 'checkbox',
                getCheckboxProps: (record) => ({
                    name: record._id,
                    disabled: record.candidate.level !== constants.PROFILE_STATUS.TEST,
                }),
                onChange: (selectedRowKeys, selectedRows: any) => {
                    setSelectedRow(selectedRows.map(ele => ele.candidate))
                },
            },
        },
        actions: [selected.length > 0 && { name: 'move to next', actionType: 'Add', onClick: () => onMoveToNext() }],
        getColumns: () => {
            return [
                {
                    title: 'Candidate Name',
                    dataIndex: 'candidate',
                    render: (text, record) => {
                        return <span>{record?.candidate?.firstName} {record?.candidate?.lastName}</span>
                    },
                },
                {
                    title: 'Current Round',
                    dataIndex: 'candidate',
                    align: 'center',
                    render: (text, record) => {
                        return <span>{allLevels.find(e => e.value == record?.candidate?.level)?.name}</span>
                    },
                },
                {
                    title: 'Level',
                    dataIndex: 'candidate',
                    align: 'center',
                    render: (text, record) => {
                        return record?.candidate?.candidateType
                    },
                },
                {
                    title: 'Test Name',
                    dataIndex: 'testConfig',
                    render: (text, record) => {
                        return record?.testConfig?.name
                    },
                },
                {
                    title: 'Link Sent At',
                    dataIndex: 'linkSentAt',
                    align: 'center',
                    render: (text, record) => {
                        return moment(record?.linkSentAt).format('lll')
                    },
                },
                {
                    title: 'Link Expired At',
                    dataIndex: 'linkExpiredAfter',
                    align: 'center',
                    render: (text, record) => {
                        return moment(record?.linkSentAt).add(record?.linkExpiredAfter, record?.expiredType).format('lll')
                    },
                },
                {
                    title: 'Status',
                    dataIndex: 'testStatus',
                    align: 'center',
                    render: (text, record) => {
                        const status = record?.testStatus
                        const statusMap = {
                            'setup-in-progress': 'Setup In Progress',
                            'pending': 'Pending',
                            'completed': 'Completed',
                            'expired': 'Expired',
                            'inporgress': 'In Progress',
                            'failed': 'Failed'
                        }

                        // use Tag from antd to show status with color
                        const statusColorMap = {
                            'setup-in-progress': 'orange',
                            'pending': 'blue',
                            'completed': 'green',
                            'expired': 'red',
                            'inporgress': 'yellow',
                            'failed': 'red'
                        }
                        const color = statusColorMap[status] || 'default'
                        return <Tag bordered={false} color={color} key={status}>
                            {statusMap[status] || 'Unknown'}
                        </Tag>
                    },
                },
                {
                    title: 'Review Status',
                    dataIndex: 'testResult',
                    align: 'center',
                    render: (text, record) => {
                        const status = record?.testResult
                        const statusMap = {
                            'Hold': 'Hold',
                            'Rejected': 'Rejected',
                            'Shortlisted': 'Shortlisted',
                            'In-Review': 'In-Review'
                        }
                        const statusColorMap = {
                            'Hold': 'orange',
                            'Rejected': 'red',
                            'Shortlisted': 'green',
                            'In-Review': 'blue'
                        }
                        const color = statusColorMap[status] || 'default'
                        return <Tag bordered={false} color={color} key={status}>
                            {statusMap[status] || 'Unknown'}
                        </Tag>
                    }
                },
                {
                    title: 'Action',
                    dataIndex: 'testStatus',
                    align: 'center',
                    width: 200,
                    render: (text, record) => {
                        if (record?.testStatus === 'completed' || record?.testStatus === 'inporgress') {
                            return (
                                <Button type="link" onClick={() => setSelectedId(record?._id)}>
                                    View Report
                                </Button>
                            )
                        }
                        return <></>
                    }
                }
            ]
        }
    }

    useEffect(() => {
        if (selectedId) {
            setIsOpen(true)
        }
    }, [selectedId])


    return (
        <>
            <MasterComponent config={config} />
            <Drawer
                open={isOpen}
                title={
                    <div>
                        <div style={{ fontSize: '20px', fontWeight: 'bold' }}>Report</div>
                        <div style={{ fontSize: '14px', color: '#8c8c8c', marginTop: '4px' }}>Overview</div>
                    </div>
                }
                onClose={() => {
                    setIsOpen(false);
                    setSelectedId(null);
                }}
                width={'90%'}
                styles={{
                    body: { padding: '24px', background: '#f5f5f5' }
                }}
            >
                <Report id={selectedId} />
            </Drawer>
            <NextRoundModal isVisible={nextRound} onClose={() => setNextRound(false)} selected={selected} level={level} />
        </>
    )
}

export default QualifiedCandidates